import { render, staticRenderFns } from "./RunnerLastStarts.vue?vue&type=template&id=604ca12e"
import script from "./RunnerLastStarts.vue?vue&type=script&lang=js"
export * from "./RunnerLastStarts.vue?vue&type=script&lang=js"
import style0 from "./RunnerLastStarts.vue?vue&type=style&index=0&id=604ca12e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports